import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.auth');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type RhythmMenuId = 'taiko' | 'iidx' | 'popn' | 'sdvx';

const DEFAULT_HOME: RhythmMenuId = 'taiko';
const MENU_ORDER_STORAGE_PREFIX = 'taigo_rhythm_menu_order_v1';
const MENU_ACTIVE_OWNER_STORAGE_KEY = 'taigo_rhythm_menu_active_owner_v1';
const DEFAULT_MENU_ORDER: RhythmMenuId[] = ['taiko', 'iidx', 'popn', 'sdvx'];

@Component({
    selector: 'wiz-page-auth',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.auth/view.scss */
/* src/app/page.auth/view.scss: no such file or directory */`],
})
export class PageAuthComponent implements OnInit {
    public mode: string = 'login';
    public email: string = '';
    public password: string = '';
    public name: string = '';
    public error: string = '';
    public loading: boolean = false;
    public guestHomeHref: string = `/${DEFAULT_HOME}`;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        // 이미 로그인되어 있으면 서열표로 이동
        const { code, data } = await wiz.call("check");
        if (code === 200) {
            this.service.href(this.getPreferredHome(data));
            return;
        }
        this.guestHomeHref = this.getPreferredHome();
        await this.service.render();
    }

    public switchMode(mode: string) {
        this.mode = mode;
        this.error = '';
        this.service.render();
    }

    public async login() {
        if (!this.email || !this.password) {
            this.error = '이메일과 비밀번호를 입력해주세요';
            await this.service.render();
            return;
        }
        this.loading = true;
        this.error = '';
        await this.service.render();

        const { code, data } = await wiz.call("login", {
            email: this.email,
            password: this.password
        });

        this.loading = false;
        if (code === 200) {
            this.service.href(this.getPreferredHome(data));
            return;
        }
        this.error = data?.message || '로그인에 실패했습니다';
        await this.service.render();
    }

    public async register() {
        if (!this.email || !this.password || !this.name) {
            this.error = '모든 필드를 입력해주세요';
            await this.service.render();
            return;
        }
        this.loading = true;
        this.error = '';
        await this.service.render();

        const { code, data } = await wiz.call("register", {
            email: this.email,
            password: this.password,
            name: this.name
        });

        this.loading = false;
        if (code === 200) {
            this.service.href(this.getPreferredHome(data));
            return;
        }
        this.error = data?.message || '회원가입에 실패했습니다';
        await this.service.render();
    }

    public onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            if (this.mode === 'login') this.login();
            else this.register();
        }
    }

    private getPreferredHome(user?: any): string {
        const owner = this.getPreferenceOwnerKey(user);
        try {
            localStorage.setItem(MENU_ACTIVE_OWNER_STORAGE_KEY, owner);
            const saved = localStorage.getItem(`${MENU_ORDER_STORAGE_PREFIX}:${owner}`);
            if (!saved) return `/${DEFAULT_HOME}`;

            const order = this.normalizeMenuOrder(JSON.parse(saved));
            return `/${order[0] || DEFAULT_HOME}`;
        } catch {
            return `/${DEFAULT_HOME}`;
        }
    }

    private getPreferenceOwnerKey(user?: any): string {
        if (user?.id) return `user:${String(user.id)}`;
        if (user?.email) return `email:${String(user.email)}`;
        return 'guest';
    }

    private normalizeMenuOrder(value: any): RhythmMenuId[] {
        const order: RhythmMenuId[] = [];
        if (Array.isArray(value)) {
            for (const item of value) {
                if (this.isMenuId(item) && !order.includes(item)) order.push(item);
            }
        }

        for (const item of DEFAULT_MENU_ORDER) {
            if (!order.includes(item)) order.push(item);
        }
        return order;
    }

    private isMenuId(value: any): value is RhythmMenuId {
        return value === 'taiko' || value === 'iidx' || value === 'popn' || value === 'sdvx';
    }
}

export default PageAuthComponent;